<template>
  <v-container fill-height class="bg">
    <v-layout align-center justify-center>
      <v-flex md4>
        <v-card :loading="loading" elevation="1">
          <v-layout wrap class="pa-10" column>
            <v-layout justify-center>
              <img
                src="../assets/bfc-logo-new.png"
                alt="BFC Logo"
                class="logo"
              />
            </v-layout>
            <v-flex>
              <h2 class="db--text mt-3 font-weight-medium">
                Join the community
              </h2>
              <p class="db--text text--lighten-4 body-2 mb-5">
                Level up your French Skills by accessing latest up-to-date
                curated content.
              </p>
              <v-form v-if="forgotPassword" ref="forgotForm">
                <v-text-field
                  prepend-inner-icon="mdi-email"
                  :rules="rules.required"
                  label="Email Address"
                  type="email"
                  v-model="email"
                  filled
                ></v-text-field>
                <div class="text-right mb-4">
                  <v-btn
                    @click="sendReset"
                    depressed
                    class="primary body-1 text-capitalize"
                    >Send Reset Mail</v-btn
                  >
                </div>
              </v-form>
              <v-form v-else-if="loginState" ref="loginForm">
                <v-text-field
                  prepend-inner-icon="mdi-email"
                  :rules="rules.required"
                  label="Email Address"
                  type="email"
                  v-model="email"
                  filled
                ></v-text-field>
                <v-text-field
                  prepend-inner-icon="mdi-key-variant"
                  :rules="rules.password"
                  label="Password"
                  type="password"
                  v-model="password"
                  filled
                ></v-text-field>
                <v-btn
                  @click="login"
                  depressed
                  class="primary body-1 text-capitalize"
                  >Login</v-btn
                >
              </v-form>
              <v-form v-else ref="signupForm">
                <v-text-field
                  prepend-inner-icon="mdi-email"
                  :rules="rules.required"
                  label="Email Address"
                  type="email"
                  v-model="email"
                  filled
                ></v-text-field>
                <v-text-field
                  prepend-inner-icon="mdi-key-variant"
                  :rules="rules.password"
                  label="Password"
                  type="password"
                  v-model="password"
                  filled
                ></v-text-field>
                <v-text-field
                  prepend-inner-icon="mdi-key-variant"
                  :rules="rules.confirmPassword"
                  label="Confirm Password"
                  type="password"
                  v-model="confirmPassword"
                  filled
                ></v-text-field>
                <v-btn
                  @click="register"
                  depressed
                  class="primary body-1 text-capitalize"
                  >Signup</v-btn
                >
              </v-form>
              <p
                v-if="errorMsg"
                class="mb-1 mt-2 red--text caption font-weight-regular"
              >
                {{ errorMsg }}
              </p>
              <div v-if="!forgotPassword">
                <p
                  v-if="loginState"
                  class="mt-4 db--text pointer caption"
                  @click="loginState = false"
                >
                  Do not have any account?
                </p>
                <p
                  v-else
                  class="mt-4 db--text pointer caption"
                  @click="loginState = true"
                >
                  Already have an account?
                </p>
              </div>
            </v-flex>
            <v-layout>
              <v-spacer></v-spacer>
              <div
                class="db--text pointer caption text-right"
                @click="forgotPassword = !forgotPassword"
              >
                {{ forgotPassword ? "Back" : "Forgot Password?" }}
              </div>
            </v-layout>
            <p
              v-if="forgotPassword"
              class="mb-1 mt-2 red--text caption font-weight-regular"
            >
              {{ forgotError }}
            </p>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="forgotSent">Password successfully sent</v-snackbar>
  </v-container>
</template>

<style>
.pointer {
  cursor: pointer;
}
.w70 {
  width: 50%;
  height: auto;
  position: relative;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}
</style>

<script>
import firebase from "@/firebase";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      loading: false,
      forgotPassword: false,
      forgotError: "",
      forgotSent: false,
      loginState: true,
      email: "",
      password: "",
      confirmPassword: "",
      errorMsg: "",
      rules: {
        required: [
          (v) =>
            !!v.match(
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ) || "Enter valid email",
        ],
        password: [
          (v) => (!!v && v.length >= 6) || "Password should be minimum 6 chars",
        ],
        confirmPassword: [
          (v) => (!!v && v === this.password) || "Passwords should match",
        ],
      },
    };
  },
  watch: {
    forgotPassword(now) {
      if (!now) this.forgotError = "";
      else this.errorMsg = "";
    },
  },
  methods: {
    ...mapActions(["signIn", "signUp"]),
    async sendReset() {
      if (this.$refs.forgotForm.validate()) {
        try {
          this.loading = true;
          const auth = await firebase.auth().sendPasswordResetEmail(this.email);
          this.forgotSent = true;
          this.forgotPassword = false;
        } catch (err) {
          switch (err.code) {
            case "auth/invalid-email":
              this.forgotError = "Email not valid";
              break;
            case "auth/user-disabled":
              this.forgotError = "Account blocked, kindly contact support";
              break;
            case "auth/user-not-found":
              this.forgotError = "Email not found";
              break;
            case "auth/wrong-password":
              this.forgotError = "Password incorrect";
          }
          this.forgotErr = true;
        } finally {
          this.loading = false;
        }
      }
    },
    async login() {
      if (this.$refs.loginForm.validate()) {
        this.loading = true;
        const resp = await this.signIn({
          email: this.email,
          password: this.password,
        });
        if (!resp.success) {
          this.errorMsg = resp.errorMsg;
        }
        this.loading = false;
      }
    },
    async register() {
      if (this.$refs.signupForm.validate()) {
        this.loading = true;
        const resp = await this.signUp({
          email: this.email,
          password: this.password,
        });
        if (!resp.success) {
          this.errorMsg = resp.errorMsg;
        }
        this.loading = false;
      }
    },
  },
};
</script>
